/**
 * Dashboard Cue Notes Chips - Duplicated from My Candidates CandidatesChips
 * Same structure: ChipsContainer, watch form values, "FilterName : Value" format
 */
import React from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { ChipsContainer } from 'app/ComponentLibrary/Filter';
import { DashboardCueNotesFilterName } from './DashboardFilterUtils';

export interface DashboardCueNotesChipsProps {
  onApplyFilter: (values: Record<string, unknown>) => void;
}

export const DashboardCueNotesChips: React.FC<DashboardCueNotesChipsProps> = ({ onApplyFilter }) => {
  const { getValues, setValue, watch } = useFormContext();

  const replied = watch(DashboardCueNotesFilterName.replied);
  const search = watch(DashboardCueNotesFilterName.search);
  const placementId = watch(DashboardCueNotesFilterName.placementId);
  const dateRange = watch(DashboardCueNotesFilterName.dateRange);

  const chips = React.useMemo(() => {
    const result: Record<string, { label: string; enableDelete: boolean; value: unknown }[]> = {};
    if (replied && typeof replied === 'object' && 'value' in replied) {
      const v = (replied as { value: string }).value;
      if (v) {
        const label = v === 'true' ? 'Replied' : 'Pending Reply';
        result.replied = [
          { label: `Reply Status : ${label}`, enableDelete: true, value: replied },
        ];
      }
    }
    if (search && String(search).trim()) {
      result.search = [
        { label: `Search : ${search}`, enableDelete: true, value: search },
      ];
    }
    if (placementId && String(placementId).trim()) {
      result.placementId = [
        { label: `Placement ID : ${placementId}`, enableDelete: true, value: placementId },
      ];
    }
    if (dateRange && (dateRange.startDate || dateRange.endDate)) {
      const start = dateRange.startDate ? new Date(dateRange.startDate).toLocaleDateString() : '…';
      const end = dateRange.endDate ? new Date(dateRange.endDate).toLocaleDateString() : '…';
      result.dateRange = [
        { label: `Date Range : ${start} – ${end}`, enableDelete: true, value: dateRange },
      ];
    }
    return result;
  }, [replied, search, placementId, dateRange]);

  const handleChipDelete = (field: string) => {
    const values = getValues();
    if (field === DashboardCueNotesFilterName.replied) {
      setValue(DashboardCueNotesFilterName.replied, null);
      onApplyFilter({ ...values, replied: null });
    } else if (field === DashboardCueNotesFilterName.search) {
      setValue(DashboardCueNotesFilterName.search, '');
      onApplyFilter({ ...values, search: '' });
    } else if (field === DashboardCueNotesFilterName.placementId) {
      setValue(DashboardCueNotesFilterName.placementId, '');
      onApplyFilter({ ...values, placementId: '' });
    } else if (field === DashboardCueNotesFilterName.dateRange) {
      setValue(DashboardCueNotesFilterName.dateRange, null);
      onApplyFilter({ ...values, dateRange: null });
    }
  };

  if (Object.keys(chips).length === 0) return null;

  return (
    <Box sx={{ px: 1.5, pb: 1, pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
      <ChipsContainer chips={chips} onClick={() => {}} onDelete={handleChipDelete} />
    </Box>
  );
};
